import {
  Engine,
  Scene,
  ArcRotateCamera,
  Vector3,
  Vector4,
  MeshBuilder,
  VertexBuffer,
  StandardMaterial,
  Color3,
  Tools,
  Texture,
  HemisphericLight,
  BackgroundMaterial,
} from "@babylonjs/core";
const myScene = {
  engine: null,
  scene: null,
  createScene: function(canvas) {

    const engine = new Engine(canvas);
    const scene = new Scene(engine);
    scene.clearColor = new Color3(0.78, 0.70, 0.59);
    myScene.engine = engine;
    myScene.scene = scene;

    const plankMatWidth = new StandardMaterial("plankMatWidth");
    plankMatWidth.diffuseTexture = new Texture(require('./../../public/img/gerüstbohle-rahmen.jpg'));
    const plankMatHeight = new StandardMaterial("plankMatHeight");
    plankMatHeight.diffuseTexture = new Texture(require('./../../public/img/gerüstbohle-rahmen-hochkant.jpg'));
    const fillerMat = new StandardMaterial("fillerMat");
    fillerMat.diffuseColor = new Color3(0, 0, 0);


    /**** Set camera and light *****/
    const position = new Vector3(0, 50, 0)
    const camera = new ArcRotateCamera("camera", Tools.ToRadians(310), Tools.ToRadians(60), 300, position, scene);
    camera.attachControl(canvas, true);
    new HemisphericLight("light", new Vector3(1, 1, 0));


    var groundMat = new BackgroundMaterial("groundMat", scene);
    groundMat.diffuseTexture = new Texture(require('./../../public/texture/concreteTexture.jpg'), scene);
    groundMat.shadowLevel = 0.9;
    const ground = MeshBuilder.CreateGround("ground", {width:600, height:400});
    ground.material = groundMat;

    var wallMat = new BackgroundMaterial("wallMat", scene);
    wallMat.diffuseTexture = new Texture(require('./../../public/texture/concreteTexture.jpg'), scene);
    wallMat.shadowLevel = 0.9;
    const wall = MeshBuilder.CreateBox("box", {});
    wall.scaling.x = 600;
    wall.scaling.y = 250;
    wall.scaling.z = 1;
    wall.position.z = - 2.5;
    wall.position.y = 125;

    var faceUVwidth = new Array(6);
    faceUVwidth[0] = new Vector4(0, 0, 1, 1);
    faceUVwidth[1] = new Vector4(0, 0, 1, 1);
    faceUVwidth[2] = new Vector4(0, 0, 1, 1);
    faceUVwidth[3] = new Vector4(0, 0, 1, 1);
    faceUVwidth[4] = new Vector4(0, 0, 1, 1);
    faceUVwidth[5] = new Vector4(0, 0, 1, 1);
    var faceUVheight = new Array(6);
    faceUVheight[0] = new Vector4(0, 0, 1, 1);
    faceUVheight[1] = new Vector4(0, 0, 1, 1);
    faceUVheight[2] = new Vector4(0, 0, 1, 1);
    faceUVheight[3] = new Vector4(0, 0, 1, 1);
    faceUVheight[4] = new Vector4(0, 0, 1, 1);
    faceUVheight[5] = new Vector4(0, 0, 1, 1);

    const plank1 = MeshBuilder.CreateBox("plank1", {faceUV: faceUVwidth, wrap: true, updatable: true});
    plank1.scaling.x = 32;
    plank1.scaling.y = 4;
    plank1.scaling.z = 3;
    plank1.material = plankMatWidth;
    plank1.position.y = 168;
    const plank2 = MeshBuilder.CreateBox("plank2", {faceUV: faceUVwidth, wrap: true, updatable: true});
    plank2.scaling.x = 32;
    plank2.scaling.y = 4;
    plank2.scaling.z = 3;
    plank2.material = plankMatWidth;
    plank2.position.y = 112;
    const plank3 = MeshBuilder.CreateBox("plank3", {faceUV: faceUVheight, wrap: true, updatable: true});
    plank3.scaling.x = 4;
    plank3.scaling.y = 60;
    plank3.scaling.z = 3;
    plank3.material = plankMatHeight;
    plank3.position.x = -18;
    plank3.position.y = 140;
    const plank4 = MeshBuilder.CreateBox("plank4", {faceUV: faceUVheight, wrap: true, updatable: true});
    plank4.scaling.x = 4;
    plank4.scaling.y = 60;
    plank4.scaling.z = 3;
    plank4.material = plankMatHeight;
    plank4.position.x = 18;
    plank4.position.y = 140;

    const filler1 = MeshBuilder.CreateBox("filler1", {updatable: true});
    filler1.scaling.x = 0;
    filler1.scaling.z = 0;
    filler1.scaling.y = 0;
    filler1.position.y = 140;
    filler1.position.z = -1;
    filler1.material = fillerMat;
    const filler2 = MeshBuilder.CreateBox("filler2", {updatable: true});
    filler2.scaling.x = 0;
    filler2.scaling.z = 0;
    filler2.scaling.y = 0;
    filler2.position.z = -1;
    filler2.material = fillerMat;
    const filler3 = MeshBuilder.CreateBox("filler3", {updatable: true});
    filler3.scaling.x = 0;
    filler3.scaling.z = 0;
    filler3.scaling.y = 0;
    filler3.position.y = 140;
    filler3.position.z = -1;
    filler3.material = fillerMat;
    const filler4 = MeshBuilder.CreateBox("filler4", {updatable: true});
    filler4.scaling.x = 0;
    filler4.scaling.z = 0;
    filler4.scaling.y = 0;
    filler4.position.y = 140;
    filler4.position.z = -1;
    filler4.material = fillerMat;

    engine.runRenderLoop(() => {
      scene.render();
    });
    window.addEventListener("resize", function () {
            engine.resize();
    });
  },

  setHeight: function(height, facePos1, facePos2) {
    this.scene.getMeshByName("plank1").position.y = 140 + height/2 -2
    this.scene.getMeshByName("plank2").position.y = 140 - height/2 +2
    this.scene.getMeshByName("plank3").scaling.y = height
    this.scene.getMeshByName("plank4").scaling.y = height

    // R_X, R_Y, L_X, R_Y, L_X, L_Y, R_X, L_Y,
    var faceUV = [
      1.0, facePos2, 0.0, facePos2, 0.0, facePos1, 1.0, facePos1,
      1.0, facePos2, 0.0, facePos2, 0.0, facePos1, 1.0, facePos1,
      1.0, facePos2, 0.0, facePos2, 0.0, facePos1, 1.0, facePos1,
      1.0, facePos2, 0.0, facePos2, 0.0, facePos1, 1.0, facePos1,
      1.0, facePos2, 0.0, facePos2, 0.0, facePos1, 1.0, facePos1,
      1.0, facePos2, 0.0, facePos2, 0.0, facePos1, 1.0, facePos1
    ]
    this.scene.getMeshByName("plank3").updateVerticesData(VertexBuffer.UVKind, faceUV)
    this.scene.getMeshByName("plank4").updateVerticesData(VertexBuffer.UVKind, faceUV)
  },
  setWidth: function(width, facePos1, facePos2) {
    this.scene.getMeshByName("plank1").scaling.x = width - 8
    this.scene.getMeshByName("plank2").scaling.x = width - 8
    this.scene.getMeshByName("plank3").position.x = - width/2 + 2
    this.scene.getMeshByName("plank4").position.x = width/2 - 2

    var faceUV = [
      facePos2, 1.0, facePos1, 1.0, facePos1, 0.0, facePos2, 0.0,
      facePos2, 1.0, facePos1, 1.0, facePos1, 0.0, facePos2, 0.0,
      facePos2, 1.0, facePos1, 1.0, facePos1, 0.0, facePos2, 0.0,
      facePos2, 1.0, facePos1, 1.0, facePos1, 0.0, facePos2, 0.0,
      facePos2, 1.0, facePos1, 1.0, facePos1, 0.0, facePos2, 0.0,
      facePos2, 1.0, facePos1, 1.0, facePos1, 0.0, facePos2, 0.0
    ]
    this.scene.getMeshByName("plank1").updateVerticesData(VertexBuffer.UVKind, faceUV)
    this.scene.getMeshByName("plank2").updateVerticesData(VertexBuffer.UVKind, faceUV)
  },
  setFiller: function(width, height, fillerType){
    switch (fillerType){
      case 'none':
        this.scene.getMeshByName("filler1").scaling.x = 0
        this.scene.getMeshByName("filler1").scaling.y = 0
        this.scene.getMeshByName("filler1").scaling.z = 0
        this.scene.getMeshByName("filler2").scaling.x = 0
        this.scene.getMeshByName("filler2").scaling.y = 0
        this.scene.getMeshByName("filler2").scaling.z = 0
        this.scene.getMeshByName("filler3").scaling.x = 0
        this.scene.getMeshByName("filler3").scaling.y = 0
        this.scene.getMeshByName("filler3").scaling.z = 0
        this.scene.getMeshByName("filler4").scaling.x = 0
        this.scene.getMeshByName("filler4").scaling.y = 0
        this.scene.getMeshByName("filler4").scaling.z = 0
      break;
      case 'passepartout':
        this.scene.getMeshByName("filler1").scaling.x = width - 8
        this.scene.getMeshByName("filler1").scaling.y = height/4
        this.scene.getMeshByName("filler1").scaling.z = 0.5
        this.scene.getMeshByName("filler1").position.y = 140 + 3/8*height-4
        this.scene.getMeshByName("filler1").position.z = 0.5
        this.scene.getMeshByName("filler2").scaling.x = width - 8
        this.scene.getMeshByName("filler2").scaling.y = height/4
        this.scene.getMeshByName("filler2").scaling.z = 0.5
        this.scene.getMeshByName("filler2").position.y = 140 - (3/8*height-4)
        this.scene.getMeshByName("filler2").position.z = 0.5
        this.scene.getMeshByName("filler3").scaling.x = width/4
        this.scene.getMeshByName("filler3").scaling.y = height - 8
        this.scene.getMeshByName("filler3").scaling.z = 0.5
        this.scene.getMeshByName("filler3").position.x = 3/8*width-4
        this.scene.getMeshByName("filler3").position.y = 140
        this.scene.getMeshByName("filler3").position.z = 0.5
        this.scene.getMeshByName("filler4").scaling.x = width/4
        this.scene.getMeshByName("filler4").scaling.y = height - 8
        this.scene.getMeshByName("filler4").scaling.z = 0.5
        this.scene.getMeshByName("filler4").position.x = -(3/8*width-4)
        this.scene.getMeshByName("filler4").position.y = 140
        this.scene.getMeshByName("filler4").position.z = 0.5
      break;
      default:
        this.scene.getMeshByName("filler1").scaling.x = width - 8
        this.scene.getMeshByName("filler1").scaling.y = height - 8
        this.scene.getMeshByName("filler1").scaling.z = 0.5
        this.scene.getMeshByName("filler1").position.y = 140
        this.scene.getMeshByName("filler1").position.z = 0.5
        this.scene.getMeshByName("filler2").scaling.x = 0
        this.scene.getMeshByName("filler2").scaling.y = 0
        this.scene.getMeshByName("filler2").scaling.z = 0
        this.scene.getMeshByName("filler3").scaling.x = 0
        this.scene.getMeshByName("filler3").scaling.y = 0
        this.scene.getMeshByName("filler3").scaling.z = 0
        this.scene.getMeshByName("filler4").scaling.x = 0
        this.scene.getMeshByName("filler4").scaling.y = 0
        this.scene.getMeshByName("filler4").scaling.z = 0
      break;
    }
  },
  setColor: function(r, g, b){
    this.scene.getMaterialByName("fillerMat").diffuseColor = new Color3(r, g, b)
  }
};
export default myScene;
